<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header bg-primary">Dettagli del paziente</div>
            <div class="card-body">
                <form [formGroup]="patientForm" *ngIf="patient && patientForm">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-2">
                                <label for="centerName">Centro{{(isRequired("centerName") ? "*" : "")}}</label>
                                <p-dropdown [options]="centerOptions" dropdownIcon="fas fa-chevron-down"
                                    [autoDisplayFirst]="false" emptyMessage="Centro" appendTo="body"
                                    formControlName="centerName"
                                    [ngClass]="{'is-invalid': patientForm.get('centerName').invalid && patientForm.get('centerName').touched}"
                                    placeholder="Centro">
                                </p-dropdown>
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('centerName').invalid && patientForm.get('centerName').touched">
                                    {{errorMessage.centerName}}
                                </small>
                            </div>
                            <div class="col-2">
                                <label>Identificativo*</label>
                                <input type="text" class="form-control" [(ngModel)]="patient.identificativo" [disabled]="!isNew"
                                    placeholder="Identificativo paziente" [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-6" style="display: none">
                                <label for="inputIdentificativo">Codice Identificativo (ID){{(isRequired("identifier") ?
                                    "*"
                                    : "")}}</label>
                                <input type="text" class="form-control" id="inputIdentificativo"
                                    [ngClass]="patientForm.get('identifier').touched && patientForm.get('identifier').invalid ? 'ng-invalid' : 'ng-valid'"
                                    placeholder="Identificativo" formControlName="identifier"
                                    [ngClass]="{'is-invalid': patientForm.get('identifier').invalid && patientForm.get('identifier').touched}">
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('identifier').invalid && patientForm.get('identifier').touched">
                                    {{errorMessage.id}}
                                </small>
                            </div>
                            <span class="col-2">
                                <label for="inputAge">Genere{{(isRequired("gender") ? "*" : "")}}</label>
                                <p-dropdown [options]="genereOptions" dropdownIcon="fas fa-chevron-down"
                                    [autoDisplayFirst]="false" emptyMessage="Genere" appendTo="body"
                                    formControlName="gender"
                                    [ngClass]="{'is-invalid': patientForm.get('gender').invalid && patientForm.get('gender').touched}"
                                    placeholder="Genere"></p-dropdown>
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('gender').invalid && patientForm.get('gender').touched">
                                    {{errorMessage.gender}}
                                </small>
                            </span>
                            <span class="col-1">
                                <label for="inputAge">Et&agrave;{{(isRequired("age") ? "*" : "")}}</label>
                                <input type="number" id="inputAge" NumbersOnly [allowDecimals]="false"
                                    class="form-control" placeholder="Età" formControlName="age" min="1"
                                    [ngClass]="{'is-invalid': patientForm.get('age').invalid && patientForm.get('age').touched}">
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('age').invalid && patientForm.get('age').touched">
                                    {{errorMessage.age}}
                                </small>
                            </span>
                        </div>
                        <div class="row mt-3">
                            <span class="col-lg-2 col-md-3 col-sm-3 col-xs-6 informedConsentAdjust mt-3">
                                <div class="d-flex align-items-center">
                                    <p-checkbox name="radioGroup" value="show" class="mr-2" formControlName="consenso"
                                        [binary]="true"
                                        [ngClass]="{'is-invalid': patientForm.get('consenso').invalid && patientForm.get('consenso').touched}"></p-checkbox>
                                    <label for="inputAge" class="removeinformedConsentMargin">Consenso
                                        informato*</label>
                                    <i class="fa fa-info-circle ml-2 cyrcleFont"
                                        [pTooltip]="toolTipInformedConsent"></i>
                                </div>
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('consenso').invalid && patientForm.get('consenso').touched">
                                    {{errorMessage.informedConsent}}
                                </small>
                            </span>
                            <div class="col-lg-3 col-md-6 col-sm-4 col-xs-6" *ngIf="true || showSpan || this.id">
                                <label>Data accettazione Consenso Informato{{(isRequired("acceptance") ? "*" : "")}}
                                </label>
                                <div class="input-group date">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                    <input type="text" id="acceptance" class="form-control"
                                        placeholder="Data di accettazione" bsDatepicker formControlName="acceptance"
                                        [ngClass]="{'is-invalid': patientForm.get('acceptance').invalid && patientForm.get('acceptance').touched}"
                                        [bsConfig]="datePickerConf" (change)="onChangeDate($event)" />
                                </div>
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('acceptance').invalid && patientForm.get('acceptance').touched && (true || showSpan || this.id)">
                                    {{errorMessage.acceptanceDate}}
                                </small>
                            </div>
                            <div class="col-1"></div>

                            <div class="col-2">
                                <label for="inputEtichetta">Etichetta prima visita</label>
                                <input type="text" class="form-control"
                                    [ngClass]="patientForm.get('etichettaI').touched && patientForm.get('etichettaI').invalid ? 'ng-invalid' : 'ng-valid'"
                                    placeholder="Etichetta prima visita" formControlName="etichettaI"
                                    [ngClass]="{'is-invalid': patientForm.get('etichettaI').invalid && patientForm.get('etichettaI').touched}">
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('etichettaI').invalid && patientForm.get('etichettaI').touched">
                                    {{errorMessage.id}}
                                </small>
                            </div>
                            <div class="col-2">
                                <label for="inputEtichetta">Etichetta followup</label>
                                <input type="text" class="form-control"
                                    [ngClass]="patientForm.get('etichettaII').touched && patientForm.get('etichettaII').invalid ? 'ng-invalid' : 'ng-valid'"
                                    placeholder="Etichetta seconda visita" formControlName="etichettaII"
                                    [ngClass]="{'is-invalid': patientForm.get('etichettaII').invalid && patientForm.get('etichettaII').touched}">
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('etichettaII').invalid && patientForm.get('etichettaII').touched">
                                    {{errorMessage.id}}
                                </small>
                            </div>
                            <div class="col-2">
                                <label for="inputEtichetta">Etichetta visita finale</label>
                                <input type="text" class="form-control"
                                    [ngClass]="patientForm.get('etichettaIII').touched && patientForm.get('etichettaIII').invalid ? 'ng-invalid' : 'ng-valid'"
                                    placeholder="Etichetta terza visita" formControlName="etichettaIII"
                                    [ngClass]="{'is-invalid': patientForm.get('etichettaIII').invalid && patientForm.get('etichettaIII').touched}">
                                <small id="acceptance-help" class="p-error block"
                                    *ngIf="patientForm.get('etichettaIII').invalid && patientForm.get('etichettaIII').touched">
                                    {{errorMessage.id}}
                                </small>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group row">
                        <div class="col-4" *ngIf="canViewListaAssegna()">
                            <label>Assegna medici*</label>
                            <p-multiSelect appendTo="body" class="p-fluid" [defaultLabel]="defaultLabelListaMedici"
                                [options]="medici" formControlName="mediciSelezionati" [filter]="true"
                                filterBy="nome,cognome,username"
                                [ngClass]="{'is-invalid': patientForm.get('mediciSelezionati').invalid}"
                                [emptyFilterMessage]="emptyFilterMessageListaMedici" [baseZIndex]="1501">
                                <ng-template let-select pTemplate="selectedItems">
                                    <div *ngFor="let val of select">
                                        <span style="font-weight: bold;">Nome:&nbsp;</span>
                                        <span>{{val.nome}}&nbsp;</span>
                                        <span style="font-weight: bold;">Cognome:&nbsp;</span>
                                        <span>{{val.cognome}}&nbsp;</span>
                                        <span *ngIf="select.length > 1">,&nbsp;</span>
                                    </div>
                                    <span *ngIf="!select || select.length === 0"
                                        class="p-multiselected-empty-token p-corner-all">{{defaultLabelListaMedici}}</span>
                                </ng-template>
                                <ng-template let-medico pTemplate="item">
                                    <span style="font-weight: bold;">Nome:&nbsp;</span>
                                    <span>{{medico.nome}}&nbsp;</span>
                                    <span style="font-weight: bold;">Cognome:&nbsp;</span>
                                    <span>{{medico.cognome}}&nbsp;</span>
                                    <span style="font-weight: bold;">Username:&nbsp;</span>
                                    <span>{{medico.username}}&nbsp;</span>
                                </ng-template>
                            </p-multiSelect>
                        </div>
                    </div>
                    <div class="row mb-3" *ngIf="showFormDiabete">
                        <div class="col-lg-3 col-md-4 col-sm-6" style="padding-left: 0;">
                            <label>Familiarità del diabete{{(isRequired("familiaritaDiabete") ? "*" : "")}}</label>
                            <p-dropdown [options]="familiaritaDiabeteOptions" dropdownIcon="fas fa-chevron-down"
                                [autoDisplayFirst]="false" emptyMessage="Familiarità del diabete" appendTo="body"
                                formControlName="familiaritaDiabete" placeholder="Familiarità del diabete"></p-dropdown>
                            <small id="acceptance-help" class="p-error block smallDropDownAdjust"
                                *ngIf="patientForm.get('familiaritaDiabete').invalid && patientForm.get('familiaritaDiabete').touched">
                                {{errorMessage.familiarityDiabetes}}
                            </small>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6">
                            <label>Durata diabete (anni){{(isRequired("durataDiabete") ? "*" :
                                "")}}</label>
                            <p-dropdown class="row" [options]="durataDiabeteOptions" dropdownIcon="fas fa-chevron-down"
                                [autoDisplayFirst]="false" emptyMessage="Durata diabete" formControlName="durataDiabete"
                                appendTo="body" placeholder="Durata diabete"></p-dropdown>
                            <small id="acceptance-help" class="p-error block smallDropDownAdjust"
                                *ngIf="patientForm.get('durataDiabete').invalid && patientForm.get('durataDiabete').touched">
                                {{errorMessage.diabetesDuration}}
                            </small>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6" #categoriaDiabete>
                            <label>Categoria paziente{{(isRequired("categoriaDiabete") ? "*" :
                                "")}}</label>

                            <span class="p-input-icon-right" style="display:block">
                                <i class="fas fa-chevron-down"></i>
                                <input type="text" class="fakeDropdown" pInputText
                                    placeholder="Selezionare una categoria" (click)="menucategoria.toggle($event)"
                                    [readOnly]="true" formControlName="categoriaDiabete" />
                                <p-tieredMenu #menucategoria [model]="items" [popup]="true"
                                    appendTo="body"></p-tieredMenu>
                            </span>


                            <small id="acceptance-help" class="p-error block smallDropDownAdjust"
                                *ngIf="patientForm.get('categoriaDiabete').invalid && patientForm.get('categoriaDiabete').touched">
                                {{errorMessage.patientCategory}}
                            </small>
                        </div>
                        <div class="col-3">
                            <label style="visibility: hidden;">Vuota</label>
                            <div class="mt-1">
                                <p-checkbox name="radioGroup" value="control" class="mr-2" formControlName="isControl"
                                    [binary]="true"></p-checkbox>
                                <label for="isControl" class="removeinformedConsentMargin">Paziente di
                                    controllo</label>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="row"
                    *ngIf="patientForm != undefined && patientForm.get('categoriaDiabete').value != undefined && patientForm.get('categoriaDiabete').value != 'control'">
                    <div class="col-6 mt-3">
                        <form [formGroup]="formCriteriInclusione" *ngIf="patient && formCriteriInclusione">
                            <p-accordion #ref [activeIndex]="0">
                                <p-accordionTab style="pointer-events: none;">
                                    <ng-template pTemplate="header">
                                        <div class="flex align-items-center">
                                            <span class="vertical-align-middle">Criteri di inclusione</span>
                                            <!-- <i class="fa fa-info-circle ml-2 cyrcleFont"
                                                [pTooltip]="toolTipInclusionCriteria"></i> -->
                                        </div>
                                    </ng-template>
                                    <ul class="list-group list-group-unbordered mb-3">
                                        <ng-container *ngIf="patientForm.get('categoriaDiabete').value != undefined">
                                            <li class="list-group-item {{ i == 0? 'removeFirstBorderTop': ''}}"
                                                style="text-align:center; margin-top:10px"
                                                *ngFor="let control of criteriDaUsare; let i = index">
                                                <div class="row">
                                                    <div class="col-md-1 ml-3 alignCenterCircle">
                                                        <i class="fas fa-check-circle"
                                                            style="color: #009479;font-size: 1.35rem;"></i>
                                                    </div>
                                                    <div class="col-md-9" style="text-align:left">
                                                        <label style="margin-left: 1px"
                                                            class="alignCenter">{{control.value}}</label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </p-accordionTab>
                            </p-accordion>
                        </form>
                    </div>
                    <div class="col-6 mt-3">
                        <form [formGroup]="formCriteriDiEsclusione" *ngIf="patient && formCriteriDiEsclusione">
                            <p-accordion #ref [activeIndex]="0">
                                <p-accordionTab style="pointer-events: none;">
                                    <ng-template pTemplate="header">
                                        <div class="flex align-items-center">
                                            <span class="vertical-align-middle">Criteri di esclusione</span>
                                            <!-- <i class="fa fa-info-circle ml-2 cyrcleFont"
                                                [pTooltip]="toolTipExclusionCriteria"></i> -->
                                        </div>
                                    </ng-template>
                                    <ul class="list-group list-group-unbordered mb-3">
                                        <li class="list-group-item {{ i == 0? 'removeFirstBorderTop': ''}}"
                                            style="text-align:center; margin-top:10px"
                                            *ngFor="let criterio of criteriEsclusione; let i = index">
                                            <div class="row">
                                                <div class="col-md-1 ml-3 alignCenterCircle">
                                                    <i class="fas fa-times-circle"
                                                        style="color: #c82333;font-size: 1.35rem;"></i>
                                                </div>
                                                <div class="col-md-9" style="text-align:left">
                                                    <label style="margin-left: 1px"
                                                        class="alignCenter">{{criterio.value}}</label>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </p-accordionTab>
                            </p-accordion>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button *ngIf="checkModify()" class="to-right p-button-success mt-3" pButton label="Salva"
                            icon="fa fa-save" iconPos="left" id="send" type="button" (click)="confirmSalva()"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="this.id && this.typeListView === 'Pazienti presi in carico' && showCredenziali">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header border-0">
                <div class="p-fluid justify-content-between">
                    <h3 class="card-title">Credenziali Mobile App</h3>
                </div>
            </div>
            <div class="card-body">
                <div class="row form-group">
                    <div class="col-4">
                        <small for="accountMobileApp">Nome utente:</small>
                        <input type="text" id="accountMobileApp" class="form-control" [(ngModel)]="nomeUtente"
                            [disabled]='true' placeholder="Nome utente">
                    </div>
                    <div class="col-4">
                        <small for="passwordMobileApp">Password:</small>
                        <input type="text" id="passwordMobileApp" class="form-control" placeholder="Password"
                            [(ngModel)]="password" [disabled]='true'>
                    </div>
                    <div class="col-4">
                        <div *ngIf="showResetPsw" class="mt-4">
                            <button pButton class="p-button" label="Password reset" (click)="confirmReset()"></button>
                        </div>
                        <p-dialog header="Password reset" [(visible)]="showModal" [style]="{width: '50vw'}">
                            <p>Hai reimpostato correttamente la password dell'utente, la nuova password è: {{password}}
                            </p>
                            <ng-template pTemplate="footer">
                                <p-button (click)="showModal=false" label="Ok" styleClass="p-button-success"></p-button>
                            </ng-template>
                        </p-dialog>

                    </div>
                </div>
                <!--<app-dettagli-attivazione-servizio></app-dettagli-attivazione-servizio>-->
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="this.id && org != 'ARKETIPO'">
    <div class="col-md-12">

        <div class="card">
            <div class="card-header border-0">
                <div class="p-fluid justify-content-between">
                    <h3 class="card-title">Gestione caregiver</h3>
                </div>
            </div>
            <div class="card-body">
                <app-related-person-detail></app-related-person-detail>
            </div>
        </div>
    </div>
</div>



<app-related-person-component [id]="patientId" [related]="null" *ngIf="patientId && org === 'NEMO'" section='patient'>
</app-related-person-component>